import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/App.css';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    // Replace with your actual EmailJS credentials
    emailjs.sendForm(
      'YOUR_SERVICE_ID',
      'YOUR_TEMPLATE_ID',
      form.current,
      'YOUR_PUBLIC_KEY'
    ).then((result) => {
      console.log(result.text);
      alert('Message sent successfully!');
      form.current.reset();
    }, (error) => {
      console.log(error.text);
      alert('Failed to send message. Please try again.');
    });
  };

  const departments = [
    {
      name: "Reservations",
      email: "reservations@talalilodge.com",
      phone: "+265 892 569 952"
    },
    {
      name: "Conference & Events",
      email: "events@talalilodge.com",
      phone: "+265 892 569 952"
    },
    {
      name: "General Inquiries",
      email: "info@talalilodge.com",
      phone: "+265 892 569 952"
    }
  ];

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <div className="contact-hero-content">
            <h1>Contact Us</h1>
            <p>We're here to help with your booking and answer any questions</p>
          </div>
        </div>
      </section>

      <section className="contact-info-section">
        <div className="container">
          <div className="contact-info-grid">
            <div className="contact-info-card">
              <div className="contact-info-icon">📍</div>
              <h3>Address</h3>
              <p>Along Area 9 Mosque Street</p>
              <p>P O Box 1912</p>
              <p>Lilongwe, Malawi</p>
            </div>
            <div className="contact-info-card">
              <div className="contact-info-icon">📧</div>
              <h3>Email</h3>
              <p><a href="mailto:reservations@talalilodge.com">reservations@talalilodge.com</a></p>
              <p><a href="mailto:info@talalilodge.com">info@talalilodge.com</a></p>
            </div>
            <div className="contact-info-card">
              <div className="contact-info-icon">📞</div>
              <h3>Phone</h3>
              <p><a href="tel:+265892569952">+265 892 569 952</a></p>
              <p><a href="tel:+2651751234">+265 1 751 234</a></p>
            </div>
            <div className="contact-info-card">
              <div className="contact-info-icon">🕒</div>
              <h3>Operating Hours</h3>
              <p>Reception: 24/7</p>
              <p>Check-in: 2:00 PM</p>
              <p>Check-out: 11:00 AM</p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="departments-section">
        <div className="container">
          <h2>Contact by Department</h2>
          <div className="departments-grid">
            {departments.map((dept, index) => (
              <div key={index} className="department-card">
                <h3>{dept.name}</h3>
                <div className="department-details">
                  <p>📧 <a href={`mailto:${dept.email}`}>{dept.email}</a></p>
                  <p>📞 <a href={`tel:${dept.phone}`}>{dept.phone}</a></p>
                </div>
                <button className="department-btn">Send Message</button>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="contact-form-section">
        <div className="container">
          <div className="form-container">
            <h2>Send us a Message</h2>
            <p>Fill out the form below and we'll get back to you within 24 hours</p>
            <form ref={form} onSubmit={sendEmail} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input type="text" id="name" name="user_name" required />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input type="email" id="email" name="user_email" required />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input type="tel" id="phone" name="user_phone" />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <select id="subject" name="subject" required>
                  <option value="">Select a subject</option>
                  <option value="booking">Room Booking</option>
                  <option value="conference">Conference Inquiry</option>
                  <option value="cancellation">Cancellation Request</option>
                  <option value="feedback">Feedback</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea id="message" name="message" rows="5" required></textarea>
              </div>
              <button type="submit" className="btn-primary">Send Message</button>
            </form>
          </div>
        </div>
      </section>

      <section className="map-section">
        <div className="container">
          <h2>Find Us</h2>
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.9)' }}>Located in Area 9, Lilongwe</p>
          <div className="map-content">
            <div className="map-placeholder">
              <h3>📍 Talali Lodge Location</h3>
              <p>Along Area 9 Mosque Street, P O Box 1912, Lilongwe</p>
              <div className="directions">
                <h4>Directions:</h4>
                <ul>
                  <li>🚗 From Lilongwe City Centre: 15 minutes drive</li>
                  <li>✈️ From Kamuzu International Airport: 25 minutes drive</li>
                  <li>🕌 Near Area 9 Mosque and Police Station</li>
                </ul>
                <div className="transport">
                  <h4>Transport Options:</h4>
                  <p>Taxi services available 24/7 • Secure parking on premises</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;